import $ from 'jquery';
//import { DarkMode } from '../../components/DarkMode';
//import { Menu } from '../../components/Menu';
import { CookiesConsent } from '../../components/CookiesConsent';
import { Form } from '../../components/Form';
import { Constant } from '../../components/Constant-table';
import { Home } from '../../components/Home';
import { Graph } from '../../components/Graph';
import { Printer } from '../../components/Summary';

//import 'bootstrap';
//import "bootstrap/dist/js/boostrap.bundle.min.js";

//import 'bootstrap/js/src/dropdown';
//import 'bootstrap/js/src/tooltip';
//import 'bootstrap/js/src/poppers';
//import 'bootstrap/js/src/button';
//import 'bootstrap/js/src/alert';
//import 'bootstrap/js/src/modal';
//import 'bootstrap/js/src/modal.js';
// import 'bootstrap/js/dist/modal';

import { Modal, Alert, Button, Collapse, Tooltip, Popover} from 'bootstrap'
window.bootstrap = {
    Alert, Button, Collapse, Tooltip, Popover, Modal
}


$(() => {
  new CookiesConsent();
  new Form();
  new Home();
  new Constant();
  new Graph();
  new Printer();
  
  /***********************************************************************************************
  * ￼Activate Tooltip everywhere
  */
  $('[data-bs-toggle="tooltip"]').each(function() {
     new bootstrap.Tooltip($(this));
  });

  $('[data-bs-toggle="popover"]').each(function() {
     new bootstrap.Popover($(this));
  });



  // var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  // var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  //     return new bootstrap.Tooltip(tooltipTriggerEl)
  // });



});



/***********************************************************************************************
* ￼Override the jquery.serialize() method to send both checked/unchecked values
*/
var originalSerializeArray = $.fn.serializeArray;
$.fn.extend({
    serializeArray: function () {
        var brokenSerialization = originalSerializeArray.apply(this);
        var checkboxValues = $(this).find('input[type=checkbox]').map(function () {
            return { 'name': this.name, 'value': this.checked };
        }).get();
        var checkboxKeys = $.map(checkboxValues, function (element) { return element.name; });
        var withoutCheckboxes = $.grep(brokenSerialization, function (element) {
            return $.inArray(element.name, checkboxKeys) == -1;
        });

        return $.merge(withoutCheckboxes, checkboxValues);
    }
});
